<template>
	<div
		id="stamps-modal"
		class="modal fade"
		tabindex="1"
		aria-labelledby="stamps-modal"
		@keyup.esc.stop.prevent="CloseModal()"
	>
		<div class="modal-dialog modal-dialog-centered modal-lg">
			<div class="modal-content">
				<GridLayout
					:reactive-sidebar="false"
					:sidebar-state="false"
				>
					<template #right-header>
						<div class="w-full flex justify-between items-center">
							<Title value="CARIMBO" />
							<div class="close-modal-container">
								<button
									id="close-modal"
									class="btn btn-close"
									@click="CloseModal()"
								>
									<i class="fas fa-times"></i>
								</button>
							</div>
						</div>
					</template>
					<template #right-content>
						<div
							ref="modalBody"
							class="modal-body main-content w-full p-3"
						>
							<div class="flex-1 w-full">
								<form
									class="w-full flex flex-col items-center gap-5"
								>
									<div class="w-full">
										<h5 class="section-header">
											DADOS DO AUTOR
										</h5>
										<div
											class="form-group w-full"
											:class="{
												'form-group--active':
													isFieldActive(
														'sworn_professional'
													),
												'field-error':
													isFieldInvalid(
														'sworn_professional'
													),
											}"
										>
											<label class="field-label">
												PROFISSIONAL JURAMENTADO
												<span class="required-mark"
													>*</span
												>
											</label>
											<div class="form-check gap-6">
												<div
													class="radio-label d-flex flex-wrap items-center gap-2"
												>
													<input
														id="sworn_professional_yes"
														v-model="
															form.sworn_professional
														"
														type="radio"
														:class="{
															'field-error':
																isFieldInvalid(
																	'sworn_professional'
																),
														}"
														value="yes"
														@focus="
															focusedField =
																'sworn_professional'
														"
														@blur="
															focusedField = ''
														"
													/>
													<label
														class="form-check-label"
														for="sworn_professional_yes"
													>
													</label>
													<span class=""> SIM </span>
												</div>
												<div
													class="radio-label d-flex flex-wrap items-center gap-2"
												>
													<input
														id="sworn_professional_no"
														v-model="
															form.sworn_professional
														"
														type="radio"
														:class="{
															'field-error':
																isFieldInvalid(
																	'sworn_professional'
																),
														}"
														value="no"
														@focus="
															focusedField =
																'sworn_professional'
														"
														@blur="
															focusedField = ''
														"
													/>
													<label
														class="form-check-label"
														for="sworn_professional_no"
													>
													</label>
													<span class=""> NÃO </span>
												</div>
											</div>
										</div>
										<div class="data-group">
											<FormGroup
												v-model="form.name"
												label="NOME"
												class="w-full"
												:readonly="true"
												:omit-info="true"
											/>
										</div>
										<div class="data-group">
											<FormGroup
												v-model="
													form.professional_advice
												"
												label="CONSELHO PROFISSIONAL"
												class="w-full md:w-8/12"
												input-type="select"
												:input-classes="[
													{
														'field-error':
															isFieldInvalid(
																'professional_advice'
															),
													},
												]"
												:options="
													constants.PROFESSIONAL_ADVICE.map(
														o => ({
															...o,
															value: o.code,
															label: `${o.code} - ${o.label}`,
														})
													)
												"
												:required="
													isRequired(
														'professional_advice'
													)
												"
												placeholder="BUSCAR CONSELHO"
												:omit-info="true"
											/>
											<FormGroup
												v-model="form.number"
												label="NÚMERO"
												class="w-full md:w-3/12"
												input-type="text"
												:input-classes="[
													{
														'field-error':
															isFieldInvalid(
																'number'
															),
													},
												]"
												formatter="numbers"
												:required="isRequired('number')"
												placeholder="NÚMERO"
												:omit-info="true"
											/>
											<FormGroup
												v-model="
													form.uf_professional_advice
												"
												label="UF"
												class="w-full md:w-1/12"
												input-type="select"
												:options="
													states.map(s => ({
														...s,
														value: s.initials,
														label: s.initials,
													}))
												"
												:input-classes="[
													{
														'field-error':
															isFieldInvalid(
																'uf_professional_advice'
															),
													},
												]"
												:required="
													isRequired(
														'uf_professional_advice'
													)
												"
												placeholder="UF"
												:omit-info="true"
											/>
										</div>
										<div class="data-group">
											<FormGroup
												v-model="form.cbo"
												label="CBO"
												class="w-full"
												input-type="select"
												:input-classes="[
													{
														'field-error':
															isFieldInvalid(
																'cbo'
															),
													},
												]"
												:options="
													constants.CBO.map(o => ({
														...o,
														value: o.code,
														label: `${o.code} - ${o.label}`,
													}))
												"
												:required="
													isRequired(
														'cbo'
													)
												"
												placeholder="CÓDIGO OU NOME DA OCUPAÇÃO"
												:omit-info="true"
											/>
										</div>
										<div class="data-group">
											<FormGroup
												v-model="form.rqe"
												label="RQE"
												class="w-full md:w-11/12"
												input-type="text"
												placeholder="DIGITE O RQE"
												:omit-info="true"
											/>
											<FormGroup
												v-model="form.uf_rqe"
												label="UF"
												class="w-full md:w-1/12"
												input-type="select"
												:options="
													states.map(s => ({
														...s,
														value: s.initials,
														label: s.initials,
													}))
												"
												:input-classes="[
													{
														'field-error':
															isUfRqeRequired &&
															submittedRequired &&
															!form.uf_qre,
													},
												]"
												:required="isUfRqeRequired"
												placeholder="UF"
												:omit-info="true"
											/>
										</div>
									</div>
									<div class="w-full">
										<h5 class="section-header">
											ALMOFADA DO CARIMBO
										</h5>
										<div
											class="form-group w-full"
											:class="{
												'form-group--active':
													isFieldActive('line_one'),
											}"
										>
											<label class="field-label">
												LINHA 1
												<span
													v-if="
														isRequired('line_one')
													"
													class="required-mark"
													>*</span
												>
											</label>
											<Editor
												:key="`line-one-${editorRenderKey}`"
												v-model="form.line_one"
												:maxlength="
													stampEditorMaxLength
												"
												:reset-selection-on-empty="
													false
												"
												:class="{
													'field-error':
														isFieldInvalid(
															'line_one'
														),
												}"
												toolbar-preset="stamps"
												:size-options="
													stampEditorSizeOptions
												"
												@focus="
													SetFocusedField('line_one')
												"
												@blur="
													ClearFocusedField(
														'line_one'
													)
												"
											/>
										</div>
										<div
											class="form-group w-full"
											:class="{
												'form-group--active':
													isFieldActive('line_two'),
											}"
										>
											<label class="field-label">
												LINHA 2
											</label>
											<Editor
												:key="`line-two-${editorRenderKey}`"
												v-model="form.line_two"
												:maxlength="
													stampEditorMaxLength
												"
												:reset-selection-on-empty="
													false
												"
												toolbar-preset="stamps"
												:size-options="
													stampEditorSizeOptions
												"
												@focus="
													SetFocusedField('line_two')
												"
												@blur="
													ClearFocusedField(
														'line_two'
													)
												"
											/>
										</div>
										<div
											class="form-group w-full"
											:class="{
												'form-group--active':
													isFieldActive('line_three'),
											}"
										>
											<label class="field-label">
												LINHA 3
											</label>
											<Editor
												:key="`line-three-${editorRenderKey}`"
												v-model="form.line_three"
												:maxlength="
													stampEditorMaxLength
												"
												:reset-selection-on-empty="
													false
												"
												toolbar-preset="stamps"
												:size-options="
													stampEditorSizeOptions
												"
												@focus="
													SetFocusedField(
														'line_three'
													)
												"
												@blur="
													ClearFocusedField(
														'line_three'
													)
												"
											/>
										</div>
									</div>
									<div class="w-full">
										<h5 class="section-header">RUBRICA</h5>
										<div
											id="signature-drop-zone"
											class="signature-drop-zone"
											tabindex="0"
										>
											<button
												v-if="!temp_signature"
												id="signature-upload-btn"
												type="button"
												class="signature-button"
												@click="UploadSignature"
											>
												<img
													class="signature-img"
													src="@/assets/svg/arrow-up-from-bracket-solid.svg"
													alt=""
												/>
											</button>
											<input
												ref="signatureInput"
												type="file"
												class="signature-file-input"
												accept="image/*"
												@change="HandleSignatureUpload"
											/>
											<div
												v-if="temp_signature"
												id="signature-preview-container"
												ref="signaturePreview"
												class="w-full h-full relative"
												@mousedown="StartSignatureDrag"
											>
												<button
													type="button"
													class="btn-delete-signature"
													@mousedown.stop
													@click.stop="
														RemoveSignature
													"
												>
													<i
														class="fas fa-trash-alt"
													></i>
												</button>
												<img
													id="signature-img-preview"
													ref="signaturePreviewImage"
													:src="temp_signature"
													crossorigin="anonymous"
													:style="signatureImageStyle"
													alt="signature preview"
													draggable="false"
													@load="SetupSignatureImage"
												/>
												<div class="zoom-controls">
													<button
														type="button"
														class="btn-zoom"
														@mousedown.stop
														@click.stop="
															ChangeSignatureZoom(
																-0.1
															)
														"
													>
														<i
															class="fas fa-minus"
														></i>
													</button>
													<button
														type="button"
														class="btn-zoom"
														@mousedown.stop
														@click.stop="
															ChangeSignatureZoom(
																0.1
															)
														"
													>
														<i
															class="fas fa-plus"
														></i>
													</button>
												</div>
											</div>
										</div>
									</div>
								</form>
							</div>
						</div>
					</template>
					<template #right-footer>
						<div
							class="w-full h-full flex justify-between items-center"
						>
							<button
								class="btn btn-danger btn-fixed-size"
								@click="CloseModal()"
							>
								CANCELAR
							</button>
							<button
								class="btn btn-success btn-fixed-size"
								@click="SaveHandler()"
							>
								SALVAR
							</button>
						</div>
					</template>
				</GridLayout>
			</div>
		</div>
	</div>
</template>

<script>
	import { mapGetters, mapActions } from 'vuex'
	import modalMixin from '@/mixins/modal'
	import Editor from '@/components/shared/Editor.vue'
	import { PROFESSIONAL_ADVICE, CBO } from '@/constants'
	import { useConfirmation, useError } from '@/composables'

	export default {
		name: 'StampsModal',
		mixins: [modalMixin],
		components: {
			Editor,
		},
		props: {
			stamp: {
				type: Object,
				default: null,
			},
		},
		data() {
			return {
				modalId: '#stamps-modal',
				focusedField: '',
				editorRenderKey: 0,
				stampEditorSizeOptions: ['10px', '12px'],
				stampEditorMaxLength: 191,
				form: {
					id: '',
					sworn_professional: '',
					name: '',
					professional_advice: '',
					number: '',
					uf_professional_advice: '',
					cbo: '',
					rqe: '',
					uf_rqe: '',
					line_one: '',
					line_two: '',
					line_three: '',
					signature: '',
				},
				temp_signature: null,
				signatureZoom: 1,
				signaturePosition: {
					x: 0,
					y: 0,
				},
				signatureImageSize: {
					width: 0,
					height: 0,
				},
				signatureDragging: false,
				signatureDragStart: {
					x: 0,
					y: 0,
					positionX: 0,
					positionY: 0,
				},
				constants: {
					PROFESSIONAL_ADVICE,
					CBO,
				},
				states: window.statesBR,
				submitted: false,
				submittedRequired: null,
				showStampsModal: false,
			}
		},
		computed: {
			...mapGetters('auth', [
				'stamps',
				'account',
				'requester_selected_id',
				'selected_stamp',
			]),
			signatureImageStyle() {
				if (
					!this.signatureImageSize.width ||
					!this.signatureImageSize.height
				) {
					return {
						maxWidth: '100%',
						maxHeight: '100%',
					}
				}

				const width = this.signatureImageSize.width * this.signatureZoom
				const height =
					this.signatureImageSize.height * this.signatureZoom

				return {
					position: 'absolute',
					width: `${width}px`,
					height: `${height}px`,
					left: `calc(50% - ${width / 2}px + ${
						this.signaturePosition.x
					}px)`,
					top: `calc(50% - ${height / 2}px + ${
						this.signaturePosition.y
					}px)`,
				}
			},
			isUfRqeRequired() {
				return !!this.form.rqe
			},
		},
		watch: {
			stamp: {
				handler(val) {
					if (!val) this.ResetSignaturePreview()
					this.form = {
						...val,
						sworn_professional:
							val.sworn_professional === true
								? 'yes'
								: val.sworn_professional === false
								? 'no'
								: null,
					}
					this.temp_signature = val.signature
				},
				immediate: true,
				deep: true,
			},
		},
		methods: {
			...mapActions('auth', ['GetAuthAccount']),
			...mapActions('system', ['StartLoading', 'FinishLoading']),
			async SaveHandler() {
				const required = this.getRequiredFields()
				this.submittedRequired = required
				this.submitted = true
				let payload = null

				await this.$nextTick()

				if (this.isFormInvalid()) {
					const firstError = this.$el.querySelector(
						'.field-error, .vs--error, .date-wrapper--error'
					)
					if (firstError) {
						firstError.scrollIntoView({
							behavior: 'smooth',
							block: 'center',
						})
					}
					return
				}

				payload = await this.BuildStampPayload()
				if (payload) await this.Save(payload)
			},
			async BuildStampPayload() {
				this.StartLoading()

				try {
					const payload = {
						...this.form,
						sworn_professional:
							this.form.sworn_professional === 'yes',
					}

					const isNewSignatureFile =
						typeof File !== 'undefined' &&
						payload.signature instanceof File
					const hasEditedExistingSignature =
						!!this.temp_signature &&
						(this.signatureZoom !== 1 ||
							this.signaturePosition.x !== 0 ||
							this.signaturePosition.y !== 0)

					if (isNewSignatureFile || hasEditedExistingSignature) {
						const croppedSignature =
							await this.GetCroppedSignatureDataUrl()

						if (croppedSignature) {
							payload.signature = croppedSignature
						} else if (!isNewSignatureFile) {
							payload.signature = this.form.signature
							useError(
								'NÃO FOI POSSÍVEL APLICAR O REPOSICIONAMENTO DA RUBRICA. PARA REPOSICIONAR, REENVIE A IMAGEM.'
							)
						}
					}
					return payload
				} catch (error) {
					console.error(error)
					useError(
						'NÃO FOI POSSÍVEL PROCESSAR A RUBRICA PARA SALVAR.'
					)
					return
				} finally {
					this.FinishLoading()
				}
			},
			GetCroppedSignatureDataUrl() {
				return new Promise(resolve => {
					const preview = this.$refs.signaturePreview
					const image = this.$refs.signaturePreviewImage

					if (
						!preview ||
						!image ||
						!image.naturalWidth ||
						!image.naturalHeight
					) {
						resolve(this.temp_signature)
						return
					}

					const previewRect = preview.getBoundingClientRect()
					const canvas = document.createElement('canvas')
					const scale = window.devicePixelRatio || 1
					canvas.width = Math.round(previewRect.width * scale)
					canvas.height = Math.round(previewRect.height * scale)

					const ctx = canvas.getContext('2d')
					ctx.setTransform(scale, 0, 0, scale, 0, 0)
					ctx.clearRect(0, 0, previewRect.width, previewRect.height)

					const placement = this.GetSignaturePlacement(previewRect)

					ctx.drawImage(
						image,
						placement.x,
						placement.y,
						placement.width,
						placement.height
					)

					try {
						resolve(canvas.toDataURL('image/png'))
					} catch (error) {
						resolve(null)
					}
				})
			},
			GetSignaturePlacement(previewRect) {
				const width = this.signatureImageSize.width * this.signatureZoom
				const height =
					this.signatureImageSize.height * this.signatureZoom

				return {
					width,
					height,
					x:
						(previewRect.width - width) / 2 +
						this.signaturePosition.x,
					y:
						(previewRect.height - height) / 2 +
						this.signaturePosition.y,
				}
			},
			async Save(stampData) {
				return window.api
					.call('post', '/save-stamp', stampData)
					.then(async ({ data }) => {
						if (data.response) {
							await this.GetAuthAccount()

							useConfirmation()
							this.CloseModal()
						} else {
							useError(
								data?.message?.toUpperCase() ??
									'HOUVE UM ERRO AO CONCLUIR, CONTATE O SUPORTE.'
							)
						}
					})
					.finally(() => {
						this.FinishLoading()
					})
			},
			SetFocusedField(field) {
				this.focusedField = field
			},
			ClearFocusedField(field) {
				if (this.focusedField === field) {
					this.focusedField = ''
				}
			},
			RefreshEditors() {
				this.editorRenderKey += 1
			},
			HandleSignatureUpload(event) {
				if (event.target.files) {
					const reader = new FileReader()
					const file = event.target.files[0]

					if (file) {
						this.form.signature = file
						this.signatureZoom = 1
						this.signaturePosition = {
							x: 0,
							y: 0,
						}
						this.signatureImageSize = {
							width: 0,
							height: 0,
						}

						reader.onload = e =>
							(this.temp_signature = e.target.result)

						reader.readAsDataURL(file)
					}
				}
			},
			ChangeSignatureZoom(step) {
				this.EnsureSignatureImageSize()

				const nextZoom = this.signatureZoom + step
				this.signatureZoom = Math.min(
					4,
					Math.max(0.1, Number(nextZoom.toFixed(1)))
				)
			},
			EnsureSignatureImageSize() {
				if (
					this.signatureImageSize.width &&
					this.signatureImageSize.height
				)
					return true

				this.SetupSignatureImage()

				return (
					this.signatureImageSize.width > 0 &&
					this.signatureImageSize.height > 0
				)
			},
			SetupSignatureImage() {
				const preview = this.$refs.signaturePreview
				const image = this.$refs.signaturePreviewImage

				if (
					!preview ||
					!image ||
					!image.naturalWidth ||
					!image.naturalHeight
				)
					return

				const previewRect = preview.getBoundingClientRect()
				const coverScale = Math.max(
					previewRect.width / image.naturalWidth,
					previewRect.height / image.naturalHeight
				)

				this.signatureImageSize = {
					width: image.naturalWidth * coverScale,
					height: image.naturalHeight * coverScale,
				}
			},
			StartSignatureDrag(event) {
				if (!this.temp_signature) return
				if (!this.EnsureSignatureImageSize()) return

				event.preventDefault()
				this.signatureDragging = true
				this.signatureDragStart = {
					x: event.clientX,
					y: event.clientY,
					positionX: this.signaturePosition.x,
					positionY: this.signaturePosition.y,
				}
				window.addEventListener('mousemove', this.DragSignature)
				window.addEventListener('mouseup', this.StopSignatureDrag)
			},
			DragSignature(event) {
				if (!this.signatureDragging) return

				this.signaturePosition = {
					x:
						this.signatureDragStart.positionX +
						(event.clientX - this.signatureDragStart.x),
					y:
						this.signatureDragStart.positionY +
						(event.clientY - this.signatureDragStart.y),
				}
			},
			StopSignatureDrag() {
				this.signatureDragging = false
				window.removeEventListener('mousemove', this.DragSignature)
				window.removeEventListener('mouseup', this.StopSignatureDrag)
			},
			RemoveSignature() {
				this.form.signature = ''
				this.ResetSignaturePreview()
			},
			UploadSignature() {
				this.$refs.signatureInput.click()
			},
			ResetSignaturePreview() {
				this.temp_signature = null
				this.signatureZoom = 1
				this.signaturePosition = {
					x: 0,
					y: 0,
				}
				this.signatureImageSize = {
					width: 0,
					height: 0,
				}
				this.signatureDragging = false

				if (this.$refs.signatureInput) {
					this.$refs.signatureInput.value = ''
				}
			},
			isFieldInvalid(field) {
				if (!this.submitted) return false

				if (this.submittedRequired) {
					if (!this.submittedRequired.includes(field)) return false
				} else if (!this.isRequired(field)) return false

				const value = this.form[field]

				if (typeof value === 'boolean') return false

				return (
					value === null ||
					value === undefined ||
					String(value).trim() === ''
				)
			},
			isRequired(field) {
				if (field === 'sworn_professional' || field === 'line_one')
					return true

				if (this.form.sworn_professional === 'yes') {
					return [
						'professional_advice',
						'number',
						'uf_professional_advice',
						'cbo',
					].includes(field)
				}

				if (this.isUfRqeRequired && field === 'uf_rqe') return true

				return false
			},
			isFieldActive(field) {
				const value = this.form[field]
				const hasValue =
					value !== null &&
					value !== undefined &&
					String(value).trim() !== ''
				return this.focusedField === field || hasValue
			},
			getRequiredFields() {
				const required = ['sworn_professional', 'line_one']

				if (this.form.sworn_professional === 'yes') {
					required.push(
						'professional_advice',
						'number',
						'uf_professional_advice',
						'cbo'
					)
				}

				if (this.isUfRqeRequired) {
					required.push('uf_rqe')
				}

				return required
			},
			isFormInvalid() {
				const required = this.getRequiredFields()

				return required.some(field => this.isFieldInvalid(field))
			},
		},
		mounted() {
			this.OpenModal()
			this.RefreshEditors()
		},
		beforeUnmount() {
			this.StopSignatureDrag()
		},
	}
</script>

<style lang="scss" scoped>
	#stamps-modal {
		.modal-dialog {
			max-width: 100vw;
			max-height: 100vh;
			margin: 0;

			.modal-content {
				height: 100vh;
				display: flex;
				flex-direction: column;
				align-items: center;
			}
		}

		.grid-layout {
			height: 100vh;
			font-family: 'Avenir Next Light', sans-serif;

			.main-content {
				max-height: calc(
					100vh - 2.775rem - var(--secondaryQuadrantHeight) * 2
				);
			}
		}

		.grid-layout input.form-control {
			background-color: var(--newBackground);

			&::placeholder {
				color: var(--textPlaceholder);
			}
		}

		.grid-layout input.form-control:focus {
			background-color: var(--newColor);
		}

		.section-header {
			display: flex;
			align-items: center;
			justify-content: center;
			gap: 1rem;
			color: var(--fontColor);
			font-weight: bold;
			letter-spacing: 0.15em;
			margin: 1.25rem 0;
			font-family: 'Avenir Next Light', sans-serif;
		}

		.field-label {
			display: flex;
			align-items: center;
			text-transform: uppercase;
			font-size: 0.875rem;
			font-weight: 700;
			color: #475569;
			margin-bottom: 0.375rem;
			white-space: nowrap;
			padding: 0;
		}

		.required-mark {
			color: var(--requiredColor);
			margin-left: 0.125rem;
			font-size: 0.75rem;
		}

		.select-button {
			background-color: var(--backgroundColorActiveNotSelected);
			border: 0.063rem solid var(--borderColorActiveNotSelected);
			color: var(--fontColorActiveNotSelected);
			text-transform: uppercase;

			&::placeholder {
				color: var(--fontColorActiveNotSelected);
				opacity: 1;
			}

			option {
				color: var(--fontColorOptionHover);
				background-color: var(--optionBackgroundColor);
				text-transform: uppercase;

				&:hover {
					color: var(--fontColorOptionHover);
					background-color: var(--optionBackgroundColor);
				}
			}

			&:disabled {
				background-color: var(--backgroundColorInactive);
				color: var(--fontColorInactive);
				cursor: not-allowed !important;
			}
		}

		.form-control {
			padding: 0.375rem 0.625rem;
			height: 2rem !important;
			// font-family: 'Avenir Next Regular', sans-serif !important;
			font-size: 0.75rem;

			&:focus {
				background-color: var(--backgroundColorActiveNotSelected);
				border: 0.063rem solid var(--borderColorActiveNotSelected);
				color: var(--fontColor);
			}

			&:not(:placeholder-shown) {
				background-color: var(--newColor) !important;
				border: 0.063rem solid var(--newColor);
				color: var(--fontColorActiveSelected);
				font-size: 0.875rem;
			}

			&:disabled {
				background-color: var(--backgroundColor) !important;
				color: var(--newColor);
				border: 0.063rem solid var(--newColor);
				cursor: not-allowed !important;
			}
		}

		.form-group--active .field-label {
			color: var(--newColor);
		}

		::v-deep .v-select {
			--vs-controls-color: var(--fontColorActiveNotSelected);
			--vs-border-color: var(--borderColorActiveNotSelected);
			--vs-border-width: 1px;
			--vs-border-radius: 8px;

			--vs-line-height: 1.4;
			--vs-font-size: 0.875rem;

			--vs-bg: var(--backgroundColorActiveNotSelected);
			--vs-selected-color: var(--fontColorActiveNotSelected);

			--vs-search-input-color: var(--textPlaceholder);
			--vs-search-input-bg: var(--newBackground);
			--vs-search-input-placeholder-color: var(--textPlaceholder);

			--vs-dropdown-bg: var(--optionBackgroundColor);
			--vs-dropdown-color: var(--fontColorOption);
			--vs-dropdown-box-shadow: 0 4px 16px rgba(0, 0, 0, 0.5);

			--vs-actions-padding: 1px 6px 0 3px;

			--vs-dropdown-option-padding: 4px 16px;
			--vs-dropdown-option-color: var(--fontColorOption);
			--vs-dropdown-option--active-bg: var(--optionBackgroundColor);
			--vs-dropdown-option--active-color: var(--fontColor);

			--vs-state-disabled-bg: var(--backgroundColorInactive);
			--vs-state-disabled-color: var(--fontColorInactive);
			--vs-state-disabled-controls-color: var(--fontColorInactive);
			--vs-state-disabled-cursor: not-allowed;

			.vs__dropdown-toggle {
				background-color: var(--newBackground);
				border-color: var(--elementsBorderColor);
				height: 2rem;
				padding: 0.375rem 0.5rem;
				align-items: center;
			}

			.vs--open .vs__dropdown-toggle,
			.vs__dropdown-toggle:focus-within,
			.vs__dropdown-toggle:focus {
				background-color: var(--newColor) !important;
				border-color: var(--newColor) !important;
			}

			.vs__selected-options {
				align-items: center;
				flex-wrap: nowrap;
			}

			.vs__selected {
				margin: 0;
				padding: 0;
				color: var(--fontColorActiveSelected);
			}

			&.vs--open .vs__selected {
				color: var(--fontColorActiveNotSelected);
			}

			.vs__search,
			.vs__search:focus {
				color: var(--fontColorActiveNotSelected);
				background-color: transparent;
				font-size: 0.875rem;
				margin: 0 !important;
				padding: 0;
				line-height: 1.5;
			}

			.vs__dropdown-menu {
				background-color: rgb(57, 101, 173);
				padding: 0;
				li {
					border-bottom: 1px solid rgba(0, 0, 0, 0.1);
					padding: 0.5rem 0.75rem;
				}
			}

			.vs__dropdown-option {
				color: var(--fontColorOption);
				font-size: var(--vs-font-size);

				&.vs__dropdown-option--highlight {
					background-color: rgb(77, 117, 181) !important;
					color: var(--fontColorOptionHover);
				}
			}

			.vs__actions .vs__clear svg {
				width: 14px;
				height: 14px;
			}
		}

		::v-deep .v-select:has(.vs__selected) .vs__dropdown-toggle {
			background-color: var(--newColor) !important;
			border-color: var(--newColor) !important;
			font-size: var(--vs-font-size) !important;
		}

		::v-deep .v-select:has(.vs__selected) .vs__selected {
			color: var(--fontColorActiveSelected) !important;
			font-weight: 600 !important;
		}

		::v-deep .v-select:has(.vs__selected) .vs__search,
		::v-deep .v-select:has(.vs__selected) .vs__search:focus {
			color: var(--fontColorActiveSelected) !important;
		}

		.field-error {
			border-color: var(--requiredColor);
		}

		::v-deep .v-select.vs--error .vs__dropdown-toggle {
			border-color: var(--requiredColor);
		}

		.data-group {
			width: 100%;
			display: flex;
			justify-content: center;
			align-items: center;
			gap: 1rem;
		}

		.btn-close {
			background-color: var(--backgroundColor);
			width: 1.938rem;
			height: 1.938rem;
			border: none;
			border-radius: 50%;
			display: flex;
			align-items: center;
			justify-content: center;
			transition: background-color 0.2s, color 0.1s ease,
				transform 0.05s ease;

			i {
				font-size: 1.375rem;
				color: var(--elementsBorderColor);
				transition: color 0.1s ease, transform 0.05s ease;

				&:hover {
					color: var(--backgroundColorHover);
				}
			}
		}

		.radio-label {
			padding: 0.25rem 0.625rem;
			font-size: 0.75rem;
			font-family: 'Avenir Next Regular', sans-serif;
			color: #475569;
		}

		.form-group--active .radio-label {
			color: var(--newColor);
		}

		.grid-layout .form-check .form-check-label,
		.grid-layout .form-check-label::before {
			width: 1rem !important;
			height: 1rem !important;
		}

		.grid-layout .form-check input:checked ~ label:after {
			width: 1rem !important;
			height: 1rem !important;
			background: var(--newColor) !important;
			color: var(--newColor) !important;
		}

		.form-group.field-error
			.grid-layout
			.form-check
			.form-check-label::before,
		.form-group.field-error .form-check .form-check-label::before {
			border: 2px solid var(--requiredColor) !important;
			border-color: var(--requiredColor) !important;
		}

		.form-group.field-error
			.grid-layout
			.form-check
			input:checked
			~ label:after,
		.form-group.field-error .form-check input:checked ~ label:after {
			background: var(--requiredColor) !important;
			border-color: var(--requiredColor) !important;
		}

		.signature-drop-zone {
			position: relative;
			background-color: transparent;
			border: 1px solid var(--elementsBorderColor);
			height: 9.938rem;
			width: 27rem;
			display: flex;
			flex-direction: column;
			align-items: center;
			justify-content: center;
			cursor: crosshair;
			margin: 0.25rem auto 1.75rem auto;
			transition: border-color 0.2s;
			overflow: hidden;
			border-radius: 0.5rem;
			outline: none;
			position: relative;

			&:hover {
				border: 1px solid var(--newColor);
			}
		}

		.signature-button {
			display: flex;
			flex-direction: column;
			align-items: center;
			outline: none;
			border: none;
			background: none;
			cursor: pointer;

			width: 2.25rem;
			height: 2.25rem;
			background-color: var(--newColor);

			-webkit-mask: url('~@/assets/svg/arrow-up-from-bracket-solid.svg')
				no-repeat center / contain;
			mask: url('~@/assets/svg/arrow-up-from-bracket-solid.svg') no-repeat
				center / contain;

			.signature-img {
				display: none;
			}
		}

		.signature-file-input {
			display: none;
		}

		#signature-preview-container {
			width: 100%;
			height: 100%;
			display: flex;
			align-items: center;
			justify-content: center;
			position: relative;
			overflow: hidden;
			cursor: move;
			background-color: transparent;

			&:active {
				cursor: move;
			}
		}

		#signature-img-preview {
			cursor: inherit;
			flex-shrink: 0;
			user-select: none;
			transform-origin: center;
			will-change: transform;
			pointer-events: none;
		}

		.zoom-controls {
			position: absolute;
			bottom: 0.5rem;
			right: 0.5rem;
			display: flex;
			gap: 0.25rem;
			z-index: 10;
		}

		.btn-zoom {
			background-color: #040f24;
			color: var(--newColor);
			width: 1.5rem;
			height: 1.5rem;
			border-radius: 0.25rem;
			display: flex;
			align-items: center;
			justify-content: center;
			font-size: 0.75rem;
			border: 1px solid var(--newColor);
			padding: 0;
		}

		.btn-delete-signature {
			position: absolute;
			top: 0.5rem;
			right: 0.5rem;
			background-color: transparent;
			border: none;
			z-index: 10;

			i {
				font-size: 0.875rem;
				line-height: 1.25rem;
				color: var(--dangerBackgroundColor);

				&:hover {
					color: var(--deleteHoverColor);
				}
			}
		}
	}

	#stamps-modal .ql-editor {
		height: 5vh !important;
		/* overflow: hidden; */
		/* height: auto !important; */
		/* min-height: 5vh !important;
		max-height: 6vh; */
		overflow: auto !important;
		white-space: pre-wrap !important;
		overflow-wrap: break-word !important;
		word-break: break-word !important;
		box-sizing: border-box;
		width: 100%;
	}

	#stamps-modal .ql-container.ql-snow {
		border-color: var(--elementsBorderColor) !important;
		border-top: none !important;
	}

	#stamps-modal .ql-toolbar.ql-snow {
		padding: 0.188rem 8px !important;
	}

	#stamps-modal .ql-snow .ql-picker.ql-size {
		width: 2.813rem !important;
	}

	#stamps-modal .form-group.form-group--active .ql-container.ql-snow,
	#stamps-modal .ql-container.ql-snow:has(.ql-editor:not(.ql-blank)) {
		border-color: var(--newColor) !important;
		background-color: var(--newColor) !important;
	}

	#stamps-modal
		.form-group.form-group--active
		.ql-container.ql-snow
		.ql-editor,
	#stamps-modal
		.ql-container.ql-snow:has(.ql-editor:not(.ql-blank))
		.ql-editor {
		background-color: var(--newColor) !important;
		color: var(--fontColorActiveSelected) !important;
		caret-color: var(--fontColorActiveSelected) !important;
		border-radius: 0 0 8px 8px !important;
		font-family: 'Avenir Next Light', sans-serif;
		font-weight: 600 !important;
	}

	#stamps-modal .editor-container .editor-toolbar.ql-toolbar,
	#stamps-modal .editor-container .editor-toolbar.ql-toolbar.ql-snow,
	#stamps-modal .editor-container .ql-snow.ql-toolbar,
	#stamps-modal .editor-container .ql-snow .ql-toolbar {
		border-color: var(--elementsBorderColor) !important;
		background-color: var(--backgroundColor) !important;
	}

	#stamps-modal .editor-container.field-error .editor-toolbar.ql-toolbar,
	#stamps-modal
		.editor-container.field-error
		.editor-toolbar.ql-toolbar.ql-snow,
	#stamps-modal .editor-container.field-error .ql-snow.ql-toolbar,
	#stamps-modal .editor-container.field-error .ql-snow .ql-toolbar {
		border-top-color: var(--requiredColor) !important;
		border-left-color: var(--requiredColor) !important;
		border-right-color: var(--requiredColor) !important;
		background-color: var(--backgroundColor) !important;
	}

	#stamps-modal .editor-container.field-error .ql-container.ql-snow {
		border-color: var(--requiredColor) !important;
		background-color: var(--backgroundColor) !important;
	}

	#stamps-modal .editor-container.field-error .ql-editor {
		background-color: var(--newBackground) !important;
		border-radius: 0px 0px 8px 8px !important;
	}

	#stamps-modal
		.editor-container.field-error.is-active
		.editor-toolbar.ql-toolbar,
	#stamps-modal
		.editor-container.field-error.is-active
		.editor-toolbar.ql-toolbar.ql-snow,
	#stamps-modal .editor-container.field-error.is-active .ql-snow.ql-toolbar,
	#stamps-modal .editor-container.field-error.is-active .ql-snow .ql-toolbar {
		border-top-color: var(--newColor) !important;
		border-left-color: var(--newColor) !important;
		border-right-color: var(--newColor) !important;
	}

	#stamps-modal
		.editor-container.field-error.is-active
		.ql-container.ql-snow {
		border-color: var(--newColor) !important;
		background-color: var(--newColor) !important;
	}

	#stamps-modal .editor-container.field-error.is-active .ql-editor {
		background-color: var(--newColor) !important;
		color: var(--fontColorActiveSelected) !important;
		caret-color: var(--fontColorActiveSelected) !important;
	}

	#stamps-modal .editor-container.is-active .ql-toolbar,
	#stamps-modal .editor-container.is-active .ql-snow.ql-toolbar,
	#stamps-modal .editor-container.is-active .editor-toolbar.ql-toolbar {
		border-color: var(--newColor) !important;
	}

	#stamps-modal .editor-container .editor-toolbar.ql-toolbar button,
	#stamps-modal .editor-container .editor-toolbar.ql-toolbar.ql-snow button,
	#stamps-modal .editor-container .ql-snow.ql-toolbar button {
		color: var(--elementsBorderColor) !important;
	}

	#stamps-modal
		.editor-container
		.editor-toolbar.ql-toolbar
		button
		.ql-stroke,
	#stamps-modal
		.editor-container
		.editor-toolbar.ql-toolbar
		span.ql-picker
		.ql-stroke,
	#stamps-modal
		.editor-container
		.editor-toolbar.ql-toolbar.ql-snow
		button
		.ql-stroke,
	#stamps-modal
		.editor-container
		.editor-toolbar.ql-toolbar.ql-snow
		span.ql-picker
		.ql-stroke,
	#stamps-modal .editor-container .ql-snow.ql-toolbar button .ql-stroke,
	#stamps-modal
		.editor-container
		.ql-snow.ql-toolbar
		span.ql-picker
		.ql-stroke,
	#stamps-modal .editor-container .ql-snow .ql-toolbar button .ql-stroke,
	#stamps-modal
		.editor-container
		.ql-snow
		.ql-toolbar
		span.ql-picker
		.ql-stroke {
		stroke: var(--elementsBorderColor);
	}

	#stamps-modal
		.editor-container
		.ql-snow.ql-toolbar
		span.ql-picker:hover
		.ql-stroke {
		stroke: var(--newColor) !important;
	}

	#stamps-modal .editor-container .editor-toolbar.ql-toolbar button.ql-active,
	#stamps-modal
		.editor-container
		.editor-toolbar.ql-toolbar.ql-snow
		button.ql-active,
	#stamps-modal .editor-container .ql-snow.ql-toolbar button.ql-active,
	#stamps-modal
		.editor-container
		.ql-snow.ql-toolbar
		> button.ql-italic.ql-active
		> svg
		> line {
		background-color: unset;
		color: var(--newColor) !important;
		stroke: var(--newColor) !important;
	}

	#stamps-modal
		.editor-container
		.ql-snow.ql-toolbar
		.ql-picker
		.ql-picker-label.ql-active {
		color: var(--newColor) !important;
	}
</style>
